import { Action, creator } from 'src/config/rootAction';

import { Video } from '../models/Videos';

export const FETCH_VIDEOS_DATA_SUCCEEDED = 'FETCH_VIDEOS_DATA_SUCCEEDED';
export type FetchVideosDataSuccessAction = Action<typeof FETCH_VIDEOS_DATA_SUCCEEDED, Video[]>;
export const fetchVideosDataSuccess = creator<FetchVideosDataSuccessAction>(
    FETCH_VIDEOS_DATA_SUCCEEDED,
);

export const FETCH_VIDEOS_DATA_FAILED = 'FETCH_VIDEOS_DATA_FAILED';
export type FetchVideosDataFailAction = Action<typeof FETCH_VIDEOS_DATA_FAILED>;
export const fetchVideosDataFail = creator<FetchVideosDataFailAction>(FETCH_VIDEOS_DATA_FAILED);

export type VideosAction = FetchVideosDataSuccessAction | FetchVideosDataFailAction;
